import type { ReactNode } from 'react';

type WizardCheckboxRowProps = {
  inputId: string;
  checked: boolean;
  onChange: () => void;
  label: ReactNode;
  statusAnnouncement?: { id: string; text: string };
};

export const WizardCheckboxRow = ({
  inputId,
  checked,
  onChange,
  label,
  statusAnnouncement,
}: WizardCheckboxRowProps) => (
  <div className="checkbox-container">
    <input
      id={inputId}
      type="checkbox"
      checked={checked}
      aria-describedby={statusAnnouncement?.id}
      onChange={onChange}
    />
    <label className="wizard-checkbox-row__label" htmlFor={inputId}>{label}</label>
    {statusAnnouncement !== undefined ? (
      <span id={statusAnnouncement.id} className="screen-reader-text">
        {statusAnnouncement.text}
      </span>
    ) : null}
  </div>
);
